module.exports = __webpack_public_path__ + "static/media/icon-twitter-light.2d2131f3.svg";